import { Box, Text, Image, Divider } from '@chakra-ui/react'
import ritrovo_1 from '../images/0_RITROVOJPG.JPG'
import ritrovo_2 from '../images/0.jpg'
import ritrovo_3 from '../images/RITROVO1Cattura.JPG'
import scalette_5 from '../images/cinque.jpg'
import scalette_4 from '../images/4.JPG'
import scalette_6 from '../images/6.JPG'
import passaggio_pedonale_1 from '../images/8.JPG'
import passaggio_pedonale_2 from '../images/9.JPG'
import passaggio_pedonale_3 from '../images/11.JPG'
import passaggio_pedonale_4 from '../images/12.JPG'
import viapad_viajulia from '../images/13.jpg'
import verso_censt_1 from '../images/15.jpg'
import verso_censt_2 from '../images/16.jpg'
import piazza_marc from '../images/17.jpg'
import il_poeta from '../images/Il_poeta_sei_tu_che_leggi_fb.jpg'
import omero from '../images/Omero_O_L_Omertà.jpg'
import poesia from '../images/Poesia_Resistente.jpg'

const PercorsiComp = () => {
    return (
        <Box mt={[14, 14, 20]}>
            <Text fontWeight='semibold' letterSpacing={1} mt={5} mb={[1, 2, 2]} textColor='white' fontSize={[16]} ml={2}>
                RITROVO E PARTENZA | <span style={{ color: '#A0AEC0' }}>VIA CALAMO</span>
            </Text>
            <Box display='flex' flexDir={['column', null, 'row']}>
                <Box h={['500px', null, '600px']} w={['100%', null, '400px']} mb={[6, null, null]}>
                    <Image src={ritrovo_2} alt='Ritrovo 2' maxH='100%' w={['99%', null, '100%']} mx='auto' borderRadius='lg' />
                </Box>

                <Box w={['99%', '400px', '400px']} mx='auto' >
                    <Box height={['280px', null, '280px']} mb={[6, null, 10]}>
                        <Image
                            src={ritrovo_1}
                            alt='No image'
                            h='100%'
                            w={['100%', null, '100%']}
                            objectFit='cover'
                            borderRadius='lg'
                        />
                    </Box>
                    <Box height={['280px', null, '280px']} >
                        <Image src={ritrovo_3} alt='Ritrovo 3'
                            h='100%'
                            w={['100%', null, '100%']}
                            objectFit='cover'
                            borderRadius='lg'
                        />
                    </Box>
                </Box>
            </Box>

            <Text fontWeight='semibold' letterSpacing={1} mt={5} mb={[1, 2, 2]} textColor='white' fontSize={[16]} ml={2}>
                SCALETTE/ASCENSORE | <span style={{ color: '#A0AEC0' }}>VIA CALAMO</span> - VIA PADULA
            </Text>
            <Box display='flex' flexDir={['column', null, 'row']}>
                <Box h={['500px', null, '600px']} w={['100%', null, '400px']} mb={[6, null, null]}>
                    <Image src={scalette_5} alt='Ritrovo 2' maxH='100%' w={['99%', null, '400px']} mx='auto' borderRadius='lg' />
                </Box>

                <Box w={['99%', '400px', '400px']} mx='auto'>
                    <Box height={['280px', null, '280px']} mb={[6, 0, 10]}>
                        <Image
                            src={scalette_4}
                            alt='No image'
                            h='100%'
                            w={['100%', null, '100%']}
                            objectFit='cover'
                            borderRadius='lg'
                        />
                    </Box>
                    <Box height={['280px', null, '280px']} >
                        <Image src={scalette_6} alt='Ritrovo 3'
                            h='100%'
                            w={['100%', null, '100%']}
                            objectFit='cover'
                            borderRadius='lg'
                        />
                    </Box>
                </Box>
            </Box>

            <Text fontWeight='semibold' letterSpacing={1} mt={5} mb={[1, 2, 2]} textColor='white' fontSize={[16]} ml={2}>
                PASSAGGIO PEDONALE | <span style={{ color: '#A0AEC0' }}>VIA CALAMO </span> -  ANGOLO VIA PADULA N. 170
            </Text>
            <Box display='flex' flexDir={['column', null, 'row']}>
                <Box ml={[0, 0, 0]} w={['99%', '400px', '400px']} mx='auto'>
                    <Box height={['280px', null, '280px']} mb={[6, null, 10]}>
                        <Image
                            src={passaggio_pedonale_1}
                            alt='No image'
                            h='100%'
                            w={['100%', null, '100%']}
                            objectFit='cover'
                            borderRadius='lg'
                        />
                    </Box>
                    <Box height={['280px', null, '280px']} mb={[6, null, null]}>
                        <Image src={passaggio_pedonale_3} alt='Ritrovo 3'
                            h='100%'
                            w={['100%', null, '100%']}
                            objectFit='cover'
                            borderRadius='lg'
                        />
                    </Box>
                </Box>
                <Box ml={[0, 0, 0]} w={['99%', '400px', '400px']} mx='auto' alignItems='center'>
                    <Box height={['280px', null, '280px']} mb={[6, null, 10]}>
                        <Image
                            src={passaggio_pedonale_2}
                            alt='No image'
                            h='100%'
                            w={['100%', null, '100%']}
                            objectFit='cover'
                            borderRadius='lg'
                        />
                    </Box>
                    <Box height={['280px', null, '280px']} >
                        <Image src={passaggio_pedonale_4} alt='Ritrovo 3'
                            h='100%'
                            w={['100%', null, '100%']}
                            objectFit='cover'
                            borderRadius='lg'
                        />
                    </Box>
                </Box>
            </Box>

            <Text fontWeight='semibold' letterSpacing={1} mt={5} mb={[1, 2, 2]} textColor='white' fontSize={[16]} ml={2}>
                TAPPA INTERMEDIA | <span style={{ color: '#6B46C1' }}>VIA PADULA - VIA JULIA</span>
            </Text>
            <Box h={['150px', null, '400px']} w={['100%', '400px', '840px']} borderTopLeftRadius='lg'>
                <Image src={viapad_viajulia} alt='Ritrovo 2' h='100%' w={['99%', null, '100%']} borderRadius='lg' mx='auto' />
            </Box>

            <Text fontWeight='semibold' letterSpacing={1} mt={5} mb={[1, 2, 2]} textColor='white' fontSize={[16]} ml={2}>
                VERSO IL CUORE DEL <span style={{ color: '#ED8936' }}>CENTRO STORICO..</span>
            </Text>
            <Box display='flex' flexDir={['column', null, 'row']} alignItems='center'>
                <Box h={['280px', null, '400px']} w={['99%', '400px', '400px']} borderTopLeftRadius='lg' mb={[6, null, null]}>
                    <Image src={verso_censt_1} alt='Ritrovo 2' h='100%' w={['100%', null, '450px']} borderRadius='lg' />
                </Box>
                <Box h={['500px', null, '600px']} mx={['auto', null, 'auto']} w={['100%', null, '400px']}>
                    <Image src={verso_censt_2} alt='Ritrovo 2' maxH='100%' w={['99%', null, '400px']} borderRadius='lg' mx={['auto', null, null]} />
                </Box>
            </Box>

            <Text fontWeight='semibold' letterSpacing={1} mt={5} mb={[1, 2, 2]} textColor='white' fontSize={[16]} ml={2}>
                ARRIVO | <span style={{ color: '#ED8936' }}>PIAZZA MARCONI</span>
            </Text>
            <Box h={['225px', null, '400px']} borderTopLeftRadius='lg' w={['100%', null, '840px']}>
                <Image src={piazza_marc} alt='Ritrovo 2' h='100%' w={['99%', null, '100%']} borderRadius='lg' mx='auto' />
            </Box>


            <Box mt={[5, 5, 5]} mb={[3, 5, 3]} ml={2} display='flex' alignItems='center'>
                <Text fontWeight='semibold' letterSpacing={1} textColor='white' fontSize={[16]}>
                    AND
                </Text>
                <Divider borderColor='white' w={['85%', '85%', '90%']} mx='auto' />
            </Box>

            <Text fontWeight='semibold' letterSpacing={1} mb={[1, 2, 2]} textColor='white' fontSize={[16]} ml={2}>
                STREET | <span style={{ color: 'black' }}>ART</span>
            </Text>

            <Box>
                <Box h={['280px', null, '400px']} borderTopLeftRadius='lg' w={['100%', null, '840px']}>
                    <Image src={il_poeta} alt='poeta' h='100%' w={['99%', null, '100%']} borderRadius='lg' mx='auto' />
                </Box>


                <Box ml={[0, 0, 0]} w={['99%', '400px', '100%']} display='flex' flexDir={['column', null, 'row']} gap={5} mt={5} mx='auto'>
                    <Box height={['280px', null, '280px']} w={['full', null, '410px']} mb={[1, null, 10]}>
                        <Image
                            src={omero}
                            alt='No image'
                            h='100%'
                            w={['100%', null, '100%']}
                            objectFit='cover'
                            borderRadius='lg'
                        />
                    </Box>
                    <Box height={['280px', null, '280px']} w={['full', null, '410px']} mb={[1, null, null]}>
                        <Image src={poesia} alt='Ritrovo 3'
                            h='100%'
                            w={['100%', null, '100%']}
                            objectFit='cover'
                            borderRadius='lg'
                        />
                    </Box>

                </Box>
            </Box>
        </Box>
    )
}

export default PercorsiComp